import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "@lib/auth-client";

export function LoginPage() {
  const { user, login, loading } = useAuth();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const error = params.get("error");

  useEffect(() => {
    if (!loading && user) {
      window.location.href = "/";
    }
  }, [loading, user]);

  return (
    <div className="page login">
      <h1>Log in</h1>
      {error ? <p className="error">Authentication failed. Try again.</p> : null}
      <p>Use your Google account to sign in and contribute reviews.</p>
      <button type="button" onClick={() => login()}>Log in with Google</button>
    </div>
  );
}
